import React from "react";
import { Form, Button } from "semantic-ui-react";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsTable from "../ui/LmsTable";
import "../../../styles/lms/lms-loan-pages.scss";
import { IDefaultPagesProps } from "../../interfaces/Lms";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";

const LMSLoanAddUploadBudget = ({ history }) => {
  const handleUploadBudget = () => {
    // TODO: Upload Budget
  };

  return <div className="lms-flex-centered-container">
    <Form.Field>
      <label>Attachment</label>
      <input type="file" className="upload-budget-file-input"/>
    </Form.Field>
    <div>
      <Button icon={GlobalConstants.Icons.SAVE} content={"Save and Continue"} basic onClick={handleUploadBudget}/>
      <Button icon={GlobalConstants.Icons.CLOSE} content={"Close"} basic onClick={() => history.goBack()}/>
    </div>
  </div>;
};

const LMSLoanUploadBudget = ({ ...props }: IDefaultPagesProps) => {
  const { params = {}, history } = props;
  const allowedActions = ["add"];
  const { isAdd, isMainPage, isActionAllowed } = useParseRouteActions(params, allowedActions);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <LmsTable actionButtons={["add", "remove", "export"]} apiSuffix="loanUploadBudget"/>}
    {isAdd && <LMSLoanAddUploadBudget history={history}/>}
  </React.Fragment>;
};

export default LMSLoanUploadBudget;